import { ReactNode } from 'react'
import { Label } from '@/components/ui/label'

interface FormFieldProps {
  /** The label text for the field */
  label: string
  /** Whether the field is required */
  required?: boolean
  /** Error message to display */
  error?: string
  /** Help text to display below the field */
  helpText?: string
  /** The form field content */
  children: ReactNode
  /** HTML id for the field (used for label association) */
  htmlFor?: string
  /** Additional CSS classes */
  className?: string
}

export function FormField({
  label,
  required = false,
  error,
  helpText,
  children,
  htmlFor,
  className = '',
}: FormFieldProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label htmlFor={htmlFor || label.toLowerCase().replace(/\s+/g, '-')}>
        {label} {required && <span className="text-destructive">*</span>}
      </Label>
      {children}
      {error && <p className="text-sm text-destructive">{error}</p>}
      {helpText && <p className="text-xs text-muted-foreground">{helpText}</p>}
    </div>
  )
}
